export const TokenSelectField = {
  NucleusWithdrawalNote: 'NucleusWithdrawalNote',
  Filter: 'Filter',
}
export type TokenSelectField =
  (typeof TokenSelectField)[keyof typeof TokenSelectField]
